import styled from 'styled-components';
import {alignContentCss} from '../../styles/align.styled';
import {boxCss} from '../../styles/box.styled';


export const FeatureListStyled = styled.div`
  ${boxCss};

  .dfl-feature-list {
    display: flex;
    flex-wrap: wrap;

    ${alignContentCss}
    > div {
      //max-width: 300px;
      padding: 12px;
      margin: 12px;
    }
  }

`;

